import { useState, useEffect, useRef } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import { UiDatePicker, UiInput, UiButton, UiTextArea, UiRadio, UiSelect, BgLoader } from "../ui";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import chroma from "chroma-js";
import { toast } from "react-toastify";
import { instance } from "../axios";
import Dropdown from 'react-bootstrap/Dropdown';

import { useNavigate, useLocation } from "react-router-dom";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';
import { MdOutlineDragHandle, MdOutlinePerson } from "react-icons/md";
import { VscLinkExternal } from "react-icons/vsc";

const buttonlabels = { 'text': 'Quick Reply', 'url': 'Visit Website', 'call': 'Call Phone Number' };
const DragHandle = sortableHandle(() => <span className="h2 pe-3 mb-0 text-secondary"><MdOutlineDragHandle /></span>);

const SortableItem = sortableElement((value) => {
  return (
    <div className="d-flex align-items-center bg-light p-3 rounded mb-2" style={{ zIndex: 9999 }}>
      <DragHandle />
      <div className="w-100 d-flex" {...value} />
    </div>
  )
});
const SortableContainer = sortableContainer(({ children }) => {
  return <div className="position-relative">{children}</div>;
});
const WhatsappTemplate = NiceModal.create(
  ({ id, action }) => {
    const [state, setState] = useState({
      inputValue: '',
      value: [],
    });
    const modal = useModal();
    const textareaRef = useRef(null);
    const [typeCount, setTypeCount] = useState({});
    const schema = yup.object().shape({
      category: yup.string().nullable().required("Select a category"),
      template_name: yup.string().nullable().matches(/^[a-z0-9_]+$/, 'Enter template name (lower case and alphanumeric characters only)').required("Enter template name").max(150, 'Maximum character limit is 150'),
      language: yup.string().nullable().required("Select a language"),
      body: yup.string().nullable().required("Enter message content").max(1024, 'Maximum character limit is 1024'),
      buttons: yup.array().of(
        yup.object().shape({
          type: yup.string(),
          button_text: yup.string().nullable().required("This is required field").max(25, 'Maximum character limit is 25'),
          url: yup.string().when('type', {
            is: 'url',
            then: yup.string().nullable().required("This is required field").matches(/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w- .\/?%&=]*)?$/, 'Enter a valid URL'),
            otherwise: yup.string().nullable(),
          }),
          call: yup.string().when('type', {
            is: 'call',
            then: yup.string().nullable().required("This is required field").matches(/^\+?[0-9\s\-\(\)]+$/, 'Enter a valid phone number'),
            otherwise: yup.string().nullable(),
          }),
        })
      ),

    });
    const {
      register,
      handleSubmit,
      control,
      watch,
      getValues,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });


    const deleteEntry = (id) => {
      if (fields) {
        if (fields.length == 1) {
        }
      }

      remove(id)
    }

    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
      control,
      name: "buttons",
    });
    const onSortEnd = ({ oldIndex, newIndex }) => {
      move(oldIndex, newIndex)

    };


    const onSubmitHandler = async (data) => {
      SaveCF(data);
    };
    var SaveCF = (e) => {
      setState({ ...state, loader: true });


      instance({
        method: "post",
        url: "/update_wa_template",
        data: e,
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { setState({ ...state, loader: false }); });
    };


    const insertAtCursor = (text) => {
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const before = getValues('body').substring(0, start);
      const after = getValues('body').substring(end, getValues('body').length);

      const newContent = before + text + after;
      reset({
        ...getValues(),
        body: newContent
      });

      // Place cursor after inserted text
      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = start + text.length;
      }, 0);
    };

    const fetchData = () => {

      instance
        .get("/get_wa_template?id=" + id)
        .then(function (response) {
          if (response.data.status == 'success') {
            setState({ ...state, ...response.data });

            reset(response.data.template)
          } else {
            toast(response.data.msg, { type: "error" });
          }


        })
        .catch(function (error) { })
        .then(function () { });

    }

    const buttonsWatch = watch("buttons", []);


    useEffect(() => {

      fetchData();
    }, []);


    useEffect(() => {

      if (buttonsWatch == undefined) {
        return;
      }
      const countType = buttonsWatch.reduce((acc, item) => {
        acc[item.type] = (acc[item.type] || 0) + 1;
        return acc;
      }, {});
      setTypeCount(countType);
    }, [buttonsWatch]);

    const location = useLocation();
    useEffect(() => {
      if (modal.visible == true) {
        modal.hide();
      }
    }, [location]);



    return (
      <BootstrapModal size="lg" {...bootstrapDialog(modal)} >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{action} WhatsApp Template <a className="btn btn-outline-primary btn-sm ms-2" href="https://help.practive.in/portal/en/kb/articles/how-to-add-a-whatsapp-template-in-practive" target="_blank">Learn how <VscLinkExternal /></a></BootstrapModal.Title>
        </BootstrapModal.Header>
        {state.status ? (
          <form id="watemplateform" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
            <BootstrapModal.Body>

              <UiRadio
                label="Category"
                name="category"
                disabled={id == 'new' ? false : true}
                required
                message={errors.category?.message}
                options={[
                  { label: "Utility", value: "UTILITY" },
                  { label: "Marketing", value: "MARKETING" }
                ]}
                {...register("category")}
              />
              <div className="row">
                <div className="col-md-8">
                  <UiInput
                    label="Template Name"
                    required
                    disabled={id == 'new' ? false : true}
                    type="text"
                    name="template_name"
                    message={errors.template_name?.message}
                    {...register("template_name")}
                  />
                </div>
                <div className="col-md-4">
                  <UiSelect
                    label="Language"
                    required
                    disabled={id == 'new' ? false : true}
                    options={state.languages}
                    message={errors.language?.message}
                    name="language"

                    {...register('language')}
                  />
                </div>

              </div>




              <div className="d-flex align-items-center justify-content-between">
                <label class="form-label ">Body <span class="text-red font-bold text-lg">*</span></label>
                <Dropdown align="end">
             
                  <Dropdown.Toggle
                      as={React.forwardRef(({ onClick }, ref) => (
                        
                        <UiButton icon="add" className="btn btn-outline-primary btn-sm mb-1" title="Insert Variable" ref={ref}
                          onClick={(e) => {
                            e.preventDefault();
                            onClick(e);
                          }} type="button" />
                      ))}
                      id="dropdown-custom-components"
                    />

                  <Dropdown.Menu>
                    {state && state.shortcodes && state.shortcodes.map((item, index) => (
                      <Dropdown.Item key={index} onClick={() => insertAtCursor(`${item.shortcode}`)}>{item.title}</Dropdown.Item>
                    ))}

                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <Controller
                name="body"
                control={control}
                render={({ field }) => (
                  <UiTextArea
                    {...field}
                    //label="Body"
                    required
                    rows={5}
                    ref={(e) => {
                      textareaRef.current = e;
                      field.ref(e);
                    }}
                    message={errors.body?.message}
                    placeholder="Enter message content here"
                  />
                )}
              />

              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="form-label">Buttons</span>
                <div className="position-relative">
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      as={React.forwardRef(({ onClick }, ref) => (
                        
                        <UiButton icon="add" className="btn btn-outline-primary btn-sm mb-1" title="Add Button" ref={ref}
                          onClick={(e) => {
                            e.preventDefault();
                            onClick(e);
                          }} type="button" />
                      ))}
                      id="dropdown-custom-components"
                    />
                  


                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => append({ button_text: '', type: 'text' })} >Quick Reply</Dropdown.Item>
                      <Dropdown.Item onClick={() => append({ button_text: '', type: 'url' })} disabled={typeCount['url'] >= 1}>Visit Website</Dropdown.Item>
                      <Dropdown.Item onClick={() => append({ button_text: '', type: 'call' })} disabled={typeCount['call'] >= 1}>Call Phone Number</Dropdown.Item>

                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>


              <SortableContainer onSortEnd={onSortEnd} useDragHandle>
                {fields && fields.length > 0 && fields.map((value, i) => (
                  <SortableItem key={i} index={i} id={`itmm-${i}`}>
                    <div key={i} className="flex-grow-1">
                      <b>{buttonlabels[value.type]}</b>
                      <div className="row mt-2">
                        <div className="col">
                          <UiInput
                            placeholder="Button Text"
                            type="text"
                            className="mb-0"
                            name={`buttons[${i}].button_text`}
                            parentClass="mb-2"
                            message={errors.buttons?.[i]?.button_text?.message}
                            //noerror="1"
                            {...register(`buttons.[${i}].button_text`)}
                          />
                          <input type="hidden" name={`buttons[${i}].type`} value={value.type} {...register(`buttons.[${i}].type`)} />


                        </div>
                        {value.type == 'url' ?
                          <div className="col">
                            <UiInput
                              placeholder="Website URL"
                              type="text"
                              className="mb-0"
                              name={`buttons[${i}].url`}
                              parentClass="mb-2"
                              message={errors.buttons?.[i]?.url?.message}
                              //noerror="1"
                              {...register(`buttons.[${i}].url`)}
                            />
                          </div> : value.type == 'call' ?
                            <div className="col">
                              <UiInput
                                placeholder="Phone Number"
                                type="text"
                                className="mb-0"
                                name={`buttons[${i}].call`}
                                parentClass="mb-2"
                                message={errors.buttons?.[i]?.call?.message}
                                //noerror="1"
                                {...register(`buttons.[${i}].call`)}
                              />
                            </div> : null
                        }



                      </div>


                    </div>
                    <div className="" style={{ marginTop: '30px' }}>
                      <UiButton className="btn btn-outline-danger ms-3" onClick={() => deleteEntry(i)} title="" icon="delete"></UiButton>
                    </div>
                  </SortableItem>
                ))}


              </SortableContainer>


              <UiInput type="hidden" name="id" value={id} {...register("id")} />


            </BootstrapModal.Body>
            <BootstrapModal.Footer>
              <UiButton loading={state["loader"]} title="Save" />
              <a className="btn btn-secondary" onClick={modal.hide}>Cancel</a>
            </BootstrapModal.Footer>
          </form>
        ) : <BgLoader />}
      </BootstrapModal>
    );
  }
);

export default WhatsappTemplate;
